import { useLocation } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { useSelector } from '../../hooks';
import { useEffect } from 'react';
import { useNavigate } from '../../hooks/navigate';
import { Header } from '../Header/Header';
import styles from "./App.module.scss";
import { Menu } from '../Menu/Menu';
import { AppContext } from '../Menu/MenuButton';
import { YMInitializer } from 'react-yandex-metrika';
import { RealtimeProfit } from '../RealtimeProfit/RealtimeProfit';
import { PromptsProvider } from '../../providers/prompts-context';
import { ModalsCont } from '../Modal/ModalsCont';
import { init as telegramInit, miniApp, viewport } from '@telegram-apps/sdk';
//import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary';
import { useErrorTracking } from '../../hooks/error-tracking';
import { isTelegramPlatform } from '../../platform/platform';
import { DebugBar } from '../DebugBar/DebugBar';

if (isTelegramPlatform()) {
    try {
        telegramInit();
    }
    catch (error: unknown) {}
}

export const App = () => {
    const location = useLocation();
    const user = useSelector(store => store.user.info);
    const navigate = useNavigate();
    useErrorTracking();

    const isLogoPage = location.pathname === '/';
    
    useEffect(() => {
        if (!isTelegramPlatform()) {
            return;
        }

        if (miniApp.mountSync.isAvailable()) {
            miniApp.mountSync();
            miniApp.isMounted();

            miniApp.setBackgroundColor('#0F5C88');
            miniApp.setHeaderColor('#0F5C88');

            if (viewport.expand.isAvailable())
                viewport.expand();
        }
    }, []);

    useEffect(() => {
        const debugInfoBlock = document.getElementById('debug-info');
        if (debugInfoBlock)
            debugInfoBlock.remove();
    }, []);

    useEffect(() => {
        if (user.id || isLogoPage)
            return;

        navigate(AppContext.None);
    }, [user, isLogoPage, navigate]);

    const checkLocation = (skipLocations: string[]) => {
        return !skipLocations.some(skipLocation => {
            if (skipLocation.endsWith('*'))
                return location.pathname.startsWith(skipLocation.slice(0, -1));

            return location.pathname === skipLocation;
        });
    };

    const isNeedHeader = () => {
        const skipContexts = [AppContext.Quiz, AppContext.Game];
        const skipLocations = skipContexts.map(context => `/${context}/*`);
        skipLocations.push(`/${AppContext.Faq}`);
        skipLocations.push('/');
        return checkLocation(skipLocations);
    };

    const isNeedMenu = () => {
        const skipContexts = [AppContext.Game];
        const skipLocations = skipContexts.map(context => `/${context}/*`);
        skipLocations.push(`/${AppContext.Faq}`);
        return checkLocation(skipLocations) && !isLogoPage;
    };

    return (
        //<ErrorBoundary>
            <PromptsProvider>
                <div className={styles.app}>
                    <YMInitializer accounts={[ parseInt(process.env.REACT_APP_YANDEX_METRIKA_COUNTER!) ]} options={{ webvisor: true, defer: true }} />
                    { !isLogoPage && <RealtimeProfit /> }
                    { isNeedHeader() && <Header /> }
                    <AppRoutes />
                    { isNeedMenu() && <Menu /> }
                    { !isLogoPage && <ModalsCont /> }
                    <DebugBar />
                </div>
            </PromptsProvider>
        //</ErrorBoundary>
    );
};